import React, { useState } from 'react';

const PasteInputModal = ({ isOpen, onClose, onNext, onBack }) => {
  const [pastedContent, setPastedContent] = useState('');
  const [error, setError] = useState('');

  if (!isOpen) return null;

  const handleContentChange = (e) => {
    setPastedContent(e.target.value);
    if (error) setError('');
  };

  const handleNext = () => {
    if (!pastedContent.trim()) {
      setError('Please paste your member information');
      return;
    }

    onNext(pastedContent.trim());
  };

  const handleClose = () => {
    setPastedContent('');
    setError('');
    onClose();
  };

  const handleBack = () => {
    setPastedContent('');
    setError('');
    onBack();
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-lg shadow-xl w-full max-w-3xl">
        <div className="flex items-center justify-between p-6 border-b border-gray-200">
          <h2 className="text-2xl font-bold text-gray-900">Paste Your Members</h2>
          <button 
            className="text-gray-400 hover:text-gray-600 text-3xl font-light leading-none transition-colors"
            onClick={handleClose}
          >
            ×
          </button>
        </div>
        
        <div className="p-6">
          <div className="mb-4 bg-blue-50 border border-blue-200 rounded-lg p-4">
            <p className="font-medium text-gray-900 mb-2">Paste your member list below. Supported formats:</p>
            <ul className="list-disc list-inside text-sm text-gray-700 space-y-1">
              <li>CSV data with headers</li>
              <li>Simple list (one member per line)</li>
              <li>vCard format</li>
            </ul>
          </div>

          <div className="mb-3">
            <textarea
              value={pastedContent}
              onChange={handleContentChange}
              placeholder="Paste your members here...

Examples:
Name, Email, Phone
John Doe, john@example.com, (555) 123-4567
Jane Smith, jane@example.com, (555) 987-6543

Or:
John Doe john@example.com
Jane Smith jane@example.com"
              className={`w-full px-4 py-3 border ${error ? 'border-red-500' : 'border-gray-300'} rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all resize-none font-mono`}
              rows="12"
            />
            {error && <div className="text-red-600 text-sm mt-2">{error}</div>}
          </div>

          {pastedContent.trim() && (
            <div className="text-sm text-gray-600 mb-4">
              {pastedContent.trim().split('\n').length} lines detected
            </div>
          )}
          
          <div className="bg-blue-50 border border-blue-200 rounded-lg px-4 py-3 text-sm text-gray-700">
            <p>Members will be added to your community on the Yesod app.</p>
          </div>
        </div>
        
        <div className="flex items-center justify-between gap-3 px-6 py-4 border-t border-gray-200 bg-gray-50">
          <button 
            className="px-6 py-2.5 bg-white text-gray-700 border border-gray-300 rounded-lg font-medium hover:bg-gray-50 hover:border-gray-400 transition-all hover:-translate-y-px"
            onClick={handleBack}
          >
            Back
          </button>
          <button 
            className="px-6 py-2.5 bg-gradient-to-r from-indigo-600 to-purple-600 text-white rounded-lg font-medium shadow-md hover:from-indigo-700 hover:to-purple-700 transition-all hover:-translate-y-px hover:shadow-lg disabled:opacity-60 disabled:cursor-not-allowed disabled:hover:translate-y-0"
            onClick={handleNext}
            disabled={!pastedContent.trim()}
          >
            Save Members
          </button>
        </div>
      </div>
    </div>
  );
};

export default PasteInputModal;